<template>
  <div class="pa-park-list-view-set">
    <transition name="pa-simple-fade">
      <div class="list-view-set" v-if="listViewPosition === 'list'">
        <PAParkListView
        :parkList="parkList"
        />

        <PAParkListFetchButton
        :isLoading="isLoadingFetchButton"
        @handleClick="handleClickFetchButton"
        />
      </div>
    </transition>

    <transition name="pa-simple-fade">
      <div class="no-list-view-message" v-if="listViewPosition === 'no-message'">
        <PAParkListNoContentView
        :text="'まだクリップされていません。'"
        :caption="'（あなたがクリップしたひろばが表示されます。）'"
        :iconClass="['pa-icon-clip']"
        >
          <template slot="icon">
            <PAParkClipIcon />
          </template>
        </PAParkListNoContentView>
      </div>
    </transition>

    <PAParkListLoading :isLoading="isListViewLoading" />
  </div>
</template>

<script>
import PAParkListView           from '@/components/Parts/PAParkListView/PAParkListView.vue'
import PAParkListFetchButton    from '@/components/Parts/PAParkListFetchButton/PAParkListFetchButton.vue'
import PAParkListNoContentView  from '@/components/Pages/Parks/Finder/PAParkListNoContentView/PAParkListNoContentView.vue'
import PAParkListLoading        from '@/components/Parts/PAParkListLoading/PAParkListLoading.vue'

import PAParkClipIcon  from '@/components/Pages/Parks/Finder/Images/park_clip.svg?inlineN'

import {GetParkData, GetRelatedParkList} from '@/graphql/queries/Park.graphql'

export default {
  components : {
    PAParkListView,
    PAParkListFetchButton,
    PAParkListNoContentView,
    PAParkListLoading,
    PAParkClipIcon
  },

  data(){
    return {
      listViewPosition      : 'none',
      parkList              : null,
      isLoadingFetchButton  : false,
    }
  },

  apollo : {
    relatedParks : {
      query : GetRelatedParkList,
      
      variables(){
        return {
          page      : this.relatedListViewPage,
          first     : 10,
          orderBy   : [
            {
              // field : 'created_at',
              column : 'created_at',
              order : 'DESC'
            }
          ]
        };
      },

      result(result){
        const apolloClient = this.$apollo.provider.defaultClient;

        for(let park of result.data.relatedParks.data){
          apolloClient.writeQuery({
            query     : GetParkData,
            variables : {
              id  : park.id
            },
            data      : {
              park : park
            }
          });
        }

        this.$store.dispatch({
          type      : 'parkList/updateListViewData',
          listType  : 'related',
          loaded    : true
        });
      },

      skip(){
        return (this.relatedListViewPage === null);
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },

      fetchPolicy: 'no-cache'
    }
  },

  computed : {
    relatedListViewData(){
      return this.$store.state.parkList.relatedListViewData;
    },

    relatedListViewPage(){
      return this.$store.state.parkList.relatedListViewData.page;
    },

    relatedListViewLoaded(){
      return this.$store.state.parkList.relatedListViewData.loaded;
    },

    viewType(){
      return this.$route.params.viewType;
    },

    isListViewLoading(){
      if(typeof this.$apollo.queries.relatedParks === 'undefined'){
        return false;
      }else{
        return this.$apollo.queries.relatedParks.loading;
      }
    }
  },

  watch : {
    parkList : {
      handler(data){
        if(data === null){
          this.listViewPosition = 'none';
        }else if(data.length === 0 && this.relatedListViewLoaded === false){
          this.listViewPosition = 'none';
        }else if(data.length === 0 && this.relatedListViewLoaded === true){
          this.listViewPosition = 'no-message';
        }else{
          this.listViewPosition = 'list';
        }
      },
      immediate: true
    },

    relatedListViewLoaded : {
      handler(value){
        if(this.parkList === null) return;
        
        if(value === true && this.parkList.length === 0){
          this.listViewPosition = 'no-message';
        }else if (value === false && this.parkList.length === 0){
          this.listViewPosition = 'none';
        }
      },
      immediate: true
    },

    relatedListViewData  : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.parkList = data.list;
      },
      immediate:true,
      deep:true
    },

    relatedParks : {
      handler(data){
        if(typeof data === 'undefined') return;

        const listViewData = {
          list      : [],
          page      : null,
          lastPage  : null,
          total     : null
        };

        for(let park of data.data){
          listViewData.list.push({
            id  : park.id
          });
        }

        if(typeof data.paginatorInfo !== 'undefined'){
          listViewData.page     = data.paginatorInfo.currentPage;
          listViewData.lastPage = data.paginatorInfo.lastPage;
          listViewData.total    = data.paginatorInfo.total;
        }

        this.$store.dispatch({
          type      : 'parkList/updateListViewData',

          listType  : 'related',
          behaviour : 'push',
          
          list      : listViewData.list,
          page      : listViewData.page,
          lastPage  : listViewData.lastPage,
          total     : listViewData.total
        });
      },
      immediate: true
    }
  },

  methods : {
    async handleClickFetchButton(){
      this.isLoadingFetchButton = true;

      await this.UXWaiting(500);

      if(!(this.relatedListViewData.page >= this.relatedListViewData.lastPage)){
        const nextPage = (this.relatedListViewData.page + 1);

        this.$store.dispatch({
          type      : 'parkList/updateListViewData',
          listType  : 'related',
          page      : nextPage
        });
      }

      this.isLoadingFetchButton = false;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
</style>